import { useMemo } from "react";

import classnames from "classnames";

import { parseListingDisplayPrice } from "lib/utils/payment/parseListingDisplayPrice";

import { useBootstrap } from "components/store/source";
import { Button, Text } from "components/ui/source";
import { scrollToElementWithOffset } from "components/ui/source/util/scrollUtils";

import PaymentMethodMessaging from "services/stripe/elements/PaymentMethodMessaging";

import styles from "./DefaultPrice.module.scss";

function DefaultPrice({ className, collection }) {
  const { displayPrice, displayPriceLabel } = collection;
  const {
    featureFlags: { bnplListingUpsellEnabled },
  } = useBootstrap();
  const openDatePicker = e => {
    // Clicking anywhere outside the date picker will close it, so
    // we need to stop the event propagation here, otherwise the date
    // picker will see the propagated event, and then close itself.
    e.stopPropagation();
    const datePicker = document?.querySelector(
      "#start_date,[name='startDate']",
    );
    if (datePicker) {
      scrollToElementWithOffset("availability-section", "tabbar-navigation");
      datePicker.click();
    }
  };

  const stripeFormattedAmount = useMemo(() => {
    return displayPrice && bnplListingUpsellEnabled
      ? parseListingDisplayPrice(displayPrice)
      : 0;
  }, [displayPrice, bnplListingUpsellEnabled]);

  return (
    <div className={classnames(styles.container, className)}>
      <div className={styles.labelContainer}>
        <Text
          className={styles.price}
          types={["headline4", "inline", "align_right"]}
        >
          {displayPrice}
        </Text>
        <Text
          className={styles.label}
          types={["footnote", "inline", "align_right"]}
        >
          {displayPriceLabel}
        </Text>
      </div>
      <div className={styles.actions}>
        {bnplListingUpsellEnabled && (
          <PaymentMethodMessaging
            className={styles.paymentMethodMessaging}
            amount={stripeFormattedAmount}
          />
        )}
        <Button
          className={styles.selectDateButton}
          type="dark_inverted"
          onClick={openDatePicker}
          width="fit-content"
          upperCase={false}
          textProps={{
            types: ["body1", "wrap"],
            translateKey:
              "listing:availability.collection.quote.selectDatesButton",
          }}
        />
      </div>
    </div>
  );
}

export default DefaultPrice;
